import { useState } from 'react'
import CardServicos from './cardServicos'
import Container from './container'
import OtimizeSeuNegocio from './OtimizeSeuNegocio'
import AccordionServicos from './accordionServicos'

export default function SoftwareCards() {
  const [hoveredIndex, setHoveredIndex] = useState(null)
  const [expandedMobileIndex, setExpandedMobileIndex] = useState(null)
  
  // Handle accordion toggle in mobile view - similar to etapas.jsx
  const handleAccordionToggle = (index, isOpen) => {
    if (isOpen) {
      // Close any previously opened accordion
      if (expandedMobileIndex !== null && expandedMobileIndex !== index) {
        // Find the previously opened accordion and close it
        const prevAccordion = document.querySelector(`[data-accordion-index="${expandedMobileIndex}"]`);
        if (prevAccordion) {
          prevAccordion.click();
        }
      }
      setExpandedMobileIndex(index);
    } else if (expandedMobileIndex === index) {
      setExpandedMobileIndex(null);
    }
  }
  const mock = [
    {
      icon: '../assets/servicos/equipe_icon.svg',
      iconHover: '../assets/servicos/equipe_icon.svg',
      title: 'Equipe de especialistas',
      text: 'Nossa equipe é formada por arquitetos de software altamente qualificados e experientes, com expertise sólida e conhecimento técnico certificado nas mais recentes tecnologias e conectados com as tendências do mercado.',
      glowColor: '#D700E2',
      url: '',
    },
    {
      icon: '../assets/servicos/inovacao_continua_icon.svg',
      iconHover: '../assets/servicos/inovacao_continua_icon.svg',
      title: 'Inovação contínua',
      text: 'Exploramos continuamente as novas tecnologias e metodologias para garantir projetos de impacto para nossos clientes.',
      glowColor: '#D700E2',
      url: '',
    },
    {
      icon: '../assets/servicos/compromisso_excelencia_icon.svg',
      iconHover: '../assets/servicos/compromisso_excelencia_icon.svg',
      title: 'Compromisso com a excelência',
      text: 'Somos comprometidos com a excelência e asseguramos suporte contínuo e evolutivo para garantir que as soluções de projeto sejam eficientes, eficazes e tragam sucesso para os clientes.',
      glowColor: '#D700E2',
      url: '',
    },
  ]

  return (
    <div className="w-full bg-[#040116] py-[74px] md:py-28 relative overflow-hidden text-white">
      <Container className="relative z-10 space-y-6">
        {/* Desktop view with hover effect */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-6">
          {mock.map((item, index) => (
            <div 
              key={index} 
              className="relative"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <CardServicos
                icon={item.icon}
                iconHover={item.iconHover}
                title={item.title}
                text={item.text}
                glowColor={item.glowColor}
                url={item.url}
                height={380}
                className="w-full aspect-square lg:aspect-auto lg:h-full"
              />
              
              {/* Desktop OtimizeSeuNegocio that appears on hover */}
              <div 
                className={`absolute left-0 right-0 bottom-[-110px] transition-all duration-300 ${hoveredIndex === index ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
              >
                <OtimizeSeuNegocio 
                  text="Otimize seu negócio!"
                  buttonText="Contratar"
                  useFormularioRD={true}
                  type="solid"
                  className="w-full"
                />
              </div>
            </div>
          ))}
        </div>
        
        {/* Mobile view with accordion */}
        <div className="md:hidden space-y-4">
          {mock.map((item, index) => (
            <div key={index} className="relative">
              <AccordionServicos
                key={`mobile-${index}`}
                icon={item.icon}
                iconHover={item.iconHover}
                title={item.title}
                text={item.text}
                glowColor={item.glowColor}
                url={item.url}
                doesThereButton={false}
                className="bg-[rgb(36,29,73)] backdrop-blur-[92px]"
                onToggle={(isOpen) => handleAccordionToggle(index, isOpen)}
                accordionIndex={index}
              />
              
              {/* Mobile OtimizeSeuNegocio that appears when accordion is expanded */}
              <div 
                className={`transition-all duration-300 ease-in-out transform w-full overflow-hidden
                  ${expandedMobileIndex === index ? 'max-h-[100px] opacity-100' : 'max-h-0 opacity-0'}`}
                style={{
                  transitionProperty: 'max-height, opacity, transform',
                  transform: expandedMobileIndex === index ? 'translateY(0)' : 'translateY(-10px)',
                  zIndex: 20,
                  position: 'relative'
                }}
              >
                <OtimizeSeuNegocio 
                  text="Otimize seu negócio!"
                  buttonText="Contratar"
                  useFormularioRD={true}
                  type="solid"
                  className="w-full mt-4"
                />
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}
